module.exports = __webpack_public_path__ + "static/media/mouse.c01bd8a0.svg";